import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { addShift, allShifts, oneShift, removeShift, updateShift } from '../../services/shifts';
import { handleError } from '../../utilities/errorHandler';
import { Container } from 'react-bootstrap';
import CustomLoader from '../shared/CustomLoader';
import ShiftsTable from './../tables/ShiftsTable';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import ShiftForm from '../forms/ShiftForm';

const Shifts = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const [shifts, setShifts] = useState([]);
    const [shift, setShift] = useState(null);

    const getShifts = useCallback( async () => {
        setIsLoading(true);

        try {
            const response = await allShifts();
            if (response.status === 200){
                setShifts(response.data);
            }
        } catch (error){
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getShifts();
    }, [getShifts]);

    const getShift = (id) => {
        oneShift(id).then((response) => {
            if (response.status === 200) {
                setShift(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage, 'danger');
            }
        });
    }

    const deleteShift = (id) => {
        try {
            removeShift(id);
            handleMessage('Shift successfully deleted', 'success');
            getShifts();
        } catch(error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage, 'danger');
            }
        }
    }

    const saveShift = async (data) => {
        setIsSaving(true);
        try {
            const shiftData = {
                name: data.name,
                start_at: data.start_at,
                end_at: data.end_at
            }

            if (data.id){
                await updateShift(data.id, shiftData);
                handleMessage('Shift successfully updated', 'success');
                getShifts();

                return true;
            } else {
                await addShift(shiftData);
                handleMessage('Shift successfully saved', 'success');
                getShifts();

                return true;
            }
        } catch (error){
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage, 'danger');
                }
            } catch (e) {
                // error will be handled by onSubmit() in ShiftForm.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }
  return (
    <Container fluid>

        <PageTitle title='Shift Details' />

        <Message
            message={message.text}
            variant={message.variant}
            handleClose={handleCloseMessage}
            show={message.show}
        />

        <ShiftForm
            isSaving={isSaving}
            shift={shift}
            formAction={saveShift}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <ShiftsTable
                    shifts={shifts}
                    onDelete={deleteShift}
                    onEdit={getShift}
                />
            )
        }
    </Container>
  )
}

export default Shifts